import React from "react";
import NumericSpinBox from "../common/NumericSpinBox";

const NumberPicker = ({value, onChange, questionConfig}) => {


    return (
        <>
       <div className='indent flight-type'>
        <div className='flight-titles'>
            <span className='cc-subquestion-title'>
                {questionConfig.name}
            </span>
            <span className='flight-type-description'>
             {questionConfig.description}
            </span>
        </div>
        <NumericSpinBox value={value} onChange={onChange} min={questionConfig.min} max={questionConfig.max}/>

      </div>
      </>

    );
}

export default NumberPicker;